export default __webpack_public_path__ + "static/media/waste-advisor.16eabe42.png";